import type { ReactNode } from "react";

import { cx } from "../lib/cx";

/**
 * 배지 — 원본 `app.css` 의 `.badge` 계열.
 *
 * `ok` / `danger` / `warn` 의 색 일부는 사내 토큰에 없는 값입니다(성공 초록 #eefbf3/#0a7a43 등).
 * 토큰 파일은 Style Dictionary 산출물이라 여기서 고칠 수 없으므로 임의값으로 적고, 원본 CSS 와
 * 같은 값임을 주석으로 남깁니다 — 토큰에 상태색이 추가되면 이 세 줄이 교체 지점입니다.
 */

export type BadgeTone = "default" | "brand" | "ok" | "muted" | "danger" | "warn";

const TONE: Record<BadgeTone, string> = {
  default: "bg-grey-050 text-grey-600",
  brand: "bg-blue-025 text-blue-500",
  ok: "bg-[#eefbf3] text-[#0a7a43]",
  muted: "bg-grey-050 text-grey-400",
  danger: "bg-red-100 text-[#c62828]",
  warn: "bg-[#fff6eb] text-[#a65400]",
};

export function Badge({ tone = "default", children }: { tone?: BadgeTone; children: ReactNode }) {
  return (
    <span
      className={cx(
        "inline-flex items-center gap-[4px] whitespace-nowrap rounded-full px-[9px] py-[3px] text-[11px] font-bold tracking-[0.01em]",
        TONE[tone],
      )}
    >
      {children}
    </span>
  );
}
